import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from './icons';
import { WorkspaceShell } from './WorkspaceShell';

/** Экран для не-администратора (макет v6): зачем раздел и куда идти. */
export const NoAccessPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <WorkspaceShell>
      <section className="tw-screen">
        <div className="tw-card tw-empty">
          <span className="tw-done-ico tw-done-ico-gray">
            <Icon name="lock" size={44} large />
          </span>
          <h1>Этот раздел — для администратора</h1>
          <p className="tw-lead">
            Здесь собирают тесты и дают их сотрудникам. Чтобы пройти тест, этот раздел не нужен:
            ваши тесты — в главном меню, пункт «Тесты».
          </p>
          <div className="tw-row tw-btn-row" style={{ justifyContent: 'center' }}>
            <button type="button" className="tw-btn tw-btn-primary tw-btn-big" onClick={() => navigate('/tests')}>
              Перейти к моим тестам
            </button>
            <button type="button" className="tw-btn tw-btn-big" onClick={() => navigate('/')}>
              На главную
            </button>
          </div>
          <p className="tw-help">Нужно собирать тесты? Обратитесь к администратору.</p>
        </div>
      </section>
    </WorkspaceShell>
  );
};
